import { render, staticRenderFns } from "./OrderFoodNotify.vue?vue&type=template&id=1ee18637&scoped=true"
import script from "./OrderFoodNotify.vue?vue&type=script&lang=js"
export * from "./OrderFoodNotify.vue?vue&type=script&lang=js"
import style0 from "./OrderFoodNotify.vue?vue&type=style&index=0&id=1ee18637&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee18637",
  null
  
)

export default component.exports